import { render, staticRenderFns } from "./userTransfer.vue?vue&type=template&id=7466a966&scoped=true&"
import script from "./userTransfer.vue?vue&type=script&lang=js&"
export * from "./userTransfer.vue?vue&type=script&lang=js&"
import style0 from "./userTransfer.vue?vue&type=style&index=0&id=7466a966&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7466a966",
  null
  
)

export default component.exports